import PropTypes from 'prop-types';
import * as React from 'react';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { DEPRECATED_PROP_MESSAGES } from '../../constants/messages.js';
import { useId } from '../../hooks/use-id.js';
import { useNonNullishFormFieldContext } from './form.context.js';
import { createComponent } from '../core/create-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const propTypes = {
    /**
   * @deprecated  To maintain a high-quality user experience, we are no longer supporting this feature, and are not providing a direct replacement.
   */ sizeVariant: deprecatedProp(PropTypes.oneOf([
        'standard',
        'mega'
    ]), DEPRECATED_PROP_MESSAGES.noReplacement),
    /**
   * Mega adds additional top margin and centers the text
   * @deprecated To maintain a high-quality user experience, we are no longer supporting this feature, and are not providing a direct replacement.
   */ size: deprecatedProp(PropTypes.oneOf([
        'standard',
        'mega'
    ]), DEPRECATED_PROP_MESSAGES.noReplacement)
};
/**
 * @subcomponent StandardForm
 */ const FormError = createComponent({
    displayName: 'FormError',
    root: 'p',
    propTypes,
    propConfig: {
        classNames (props) {
            const classes = new Set([
                'swan-input-group-error-text'
            ]);
            if (props.sizeVariant === 'mega' || props.size === 'mega') classes.add('swan-input-group-error-text-mega');
            return classes;
        },
        processProps (props) {
            const id = useId(props.id);
            const { setErrorIds } = useNonNullishFormFieldContext();
            // add the id to the collection on load, and remove on unmount
            React.useEffect(()=>{
                if (id) {
                    setErrorIds((s)=>new Set([
                            ...s,
                            id
                        ]));
                }
                return ()=>{
                    if (id) {
                        setErrorIds((s)=>{
                            const newSet = new Set([
                                ...s
                            ]);
                            newSet.delete(id);
                            return newSet;
                        });
                    }
                };
            }, [
                id,
                setErrorIds
            ]);
            return _object_spread_props(_object_spread({}, props), {
                id
            });
        }
    }
});

export { FormError };
